export const bannerTextStyles = theme => ({
  padding: `0 ${theme.spacing(2)} 0 18px`,
});

export const boldTextStyles = {
  fontWeight: 600,
};

export const dialogStyles = theme => ({
  padding: theme.spacing(2),
});

export const dialogCloseButtonStyles = theme => ({
  color: theme.palette.graphic.main,
  position: 'absolute',
  right: 16,
  top: 16,
});

export const dialogHeaderStyles = theme => ({
  margin: 0,
  padding: 0,
  paddingTop: theme.spacing(1),
});

export const dividerStyles = theme => ({
  margin: `${theme.spacing(2)} 0`,
  width: '100%',
});

export const dividerLocationsStyles = theme => ({
  margin: `${theme.spacing(1)} 0`,
  width: '100%',
});

export const expandButtonPanelStyles = theme => ({
  borderBottom: `1px solid ${theme.palette.surface.swimlane}`,
  borderTop: `1px solid ${theme.palette.surface.swimlane}`,
  marginTop: theme.spacing(2),
  outline: 'none',
  padding: theme.spacing(2, 0),
});

export const hyperlinkStyles = theme => ({
  paddingLeft: theme.spacing(2),
});

export const listItemStyles = theme => ({
  padding: `0 ${theme.spacing(2)}`,
});

export const radioButtonStyles = theme => ({
  '& .MuiFormControlLabel-label': {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  '& label': {
    marginRight: theme.spacing(3),
    width: '100%',
  },
  '&:first-of-type': {
    marginTop: theme.spacing(1),
  },
  borderRadius: 24,
  marginTop: theme.spacing(2),
  paddingLeft: theme.spacing(2),
});

export const radioGroupStyles = theme => ({
  marginTop: theme.spacing(1),
  width: '100%',
});

export const verticallyAlignedIconStyles = theme => ({
  marginRight: theme.spacing(0.5),
  verticalAlign: 'text-bottom',
});
